import { ScrollableRow } from './ScrollableRow';

export * from './ScrollableRow';

export default ScrollableRow;
